<script lang="ts">
	import { m } from '$lib/paraglide/messages.js';
</script>

<article
	class="overflow-hidden rounded-[18px] border border-zp-line bg-white shadow-[0_40px_70px_-38px_rgba(27,24,64,0.42)]"
	aria-label={m.cap_jpc_aria()}
>
	<div class="flex items-center gap-3.5 border-b border-zp-line px-6 py-5">
		<div
			class="grid size-[46px] shrink-0 place-items-center rounded-full bg-zp-paper2 font-serif text-[1.2rem] text-zp-navy"
		>
			M
		</div>
		<div class="min-w-0 flex-1">
			<div class="text-base font-semibold text-zp-ink">Manuel R.</div>
			<div class="mt-0.5 text-[0.84rem] text-zp-muted">Bavaria 36 · RCN de Vigo</div>
		</div>
		<span
			class="shrink-0 rounded-md bg-zp-accent/12 px-2.5 py-1.5 text-[0.66rem] font-bold tracking-[0.12em] text-zp-accent uppercase"
		>
			{m.cap_jpc_badge()}
		</span>
	</div>
	<div class="px-6 py-[22px]">
		<div class="mb-5 grid grid-cols-2 gap-x-[18px] gap-y-3.5">
			<div>
				<div class="text-[0.72rem] font-semibold tracking-[0.06em] text-zp-muted uppercase">
					{m.cap_jpc_date_lbl()}
				</div>
				<div class="mt-1 text-base font-semibold text-zp-ink">{m.cap_jpc_date_val()}</div>
			</div>
			<div>
				<div class="text-[0.72rem] font-semibold tracking-[0.06em] text-zp-muted uppercase">
					{m.cap_jpc_duration_lbl()}
				</div>
				<div class="mt-1 text-base font-semibold text-zp-ink">{m.cap_jpc_duration_val()}</div>
			</div>
			<div>
				<div class="text-[0.72rem] font-semibold tracking-[0.06em] text-zp-muted uppercase">
					{m.cap_jpc_departure_lbl()}
				</div>
				<div class="mt-1 text-base font-semibold text-zp-ink">{m.cap_jpc_departure_val()}</div>
			</div>
			<div>
				<div class="text-[0.72rem] font-semibold tracking-[0.06em] text-zp-muted uppercase">
					{m.cap_jpc_passengers_lbl()}
				</div>
				<div class="mt-1 text-base font-semibold text-zp-ink">{m.cap_jpc_passengers_val()}</div>
			</div>
			<div>
				<div class="text-[0.72rem] font-semibold tracking-[0.06em] text-zp-muted uppercase">
					{m.cap_jpc_type_lbl()}
				</div>
				<div class="mt-1 text-base font-semibold text-zp-ink">{m.cap_jpc_type_val()}</div>
			</div>
			<div>
				<div class="text-[0.72rem] font-semibold tracking-[0.06em] text-zp-muted uppercase">
					{m.cap_jpc_fee_lbl()}
				</div>
				<div class="mt-1 font-serif text-[1.35rem] text-[#2f6b3a]">180€</div>
			</div>
		</div>
		<div class="grid grid-cols-[1fr_1.4fr] gap-3">
			<button
				type="button"
				class="inline-flex items-center justify-center rounded-[10px] border border-zp-line bg-white px-3.5 py-3.5 text-[0.92rem] font-semibold text-zp-muted transition-colors hover:border-[#c9536f] hover:text-[#c9536f]"
			>
				{m.cap_jpc_reject()}
			</button>
			<button
				type="button"
				class="inline-flex items-center justify-center gap-2 rounded-[10px] border border-transparent bg-zp-navy px-3.5 py-3.5 text-[0.92rem] font-semibold text-zp-paper transition-colors hover:bg-zp-ink"
			>
				{m.cap_jpc_accept()}
				<svg
					class="size-4"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					aria-hidden="true"
				>
					<path d="M20 6 9 17l-5-5" />
				</svg>
			</button>
		</div>
		<p class="mt-4 flex items-center gap-2 text-[0.82rem] leading-snug text-zp-muted">
			<svg
				class="size-4 shrink-0 text-zp-accent"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				aria-hidden="true"
			>
				<circle cx="12" cy="12" r="9" />
				<path d="M12 8v4M12 16h.01" />
			</svg>
			{m.cap_jpc_footer()}
		</p>
	</div>
</article>
